import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import {withStyles} from '@material-ui/core/styles';
import useSuccessManager from 'components/SuccessManager/useSuccessManager';
import SuccessManagerAvatar from 'components/SuccessManager/SuccessManagerAvatar';
import {IconMail} from 'components/SuccessManager/icons';
import {
  SUCCESS_MANAGER_SOURCES,
  getFullName,
  getMailto,
  trackEmailClicked
} from 'components/SuccessManager/helpers';
import {
  SidebarSuccessManagerCard,
  SidebarSuccessManagerEmail,
  SidebarSuccessManagerInfo,
  SidebarSuccessManagerLabel,
  SidebarSuccessManagerName,
  SidebarSuccessManagerRole,
  SidebarSuccessManagerSection
} from 'components/SuccessManager/styles';

const TOOLTIP_TEXT =
  'This is your dedicated Customer Success Manager. Email them for help growing your orders, setting up features, or anything about your account.';

const DarkTooltip = withStyles({
  tooltip: {
    width: 260,
    maxWidth: 260,
    backgroundColor: '#1b1d23',
    color: '#ffffff',
    fontFamily: "'Poppins', sans-serif",
    fontSize: 11,
    lineHeight: 1.5,
    padding: '12px 14px',
    borderRadius: 8,
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.25)'
  }
})(Tooltip);

// Sidebar row above the user row; hidden when the location has no CSM.
const SidebarSuccessManager = () => {
  const manager = useSuccessManager();
  if (!manager) return null;

  return (
    <DarkTooltip title={TOOLTIP_TEXT} placement='right' enterTouchDelay={0}>
      <SidebarSuccessManagerSection>
        <SidebarSuccessManagerLabel>
          Your success manager
        </SidebarSuccessManagerLabel>
        <SidebarSuccessManagerCard>
          <SuccessManagerAvatar manager={manager} variant='sidebar' />
          <SidebarSuccessManagerInfo>
            <SidebarSuccessManagerName>
              {getFullName(manager)}
            </SidebarSuccessManagerName>
            <SidebarSuccessManagerRole>
              Customer Success
            </SidebarSuccessManagerRole>
          </SidebarSuccessManagerInfo>
          <SidebarSuccessManagerEmail
            href={getMailto(manager)}
            aria-label={`Email ${manager.firstName || getFullName(manager)}`}
            onClick={() => trackEmailClicked(SUCCESS_MANAGER_SOURCES.SIDEBAR)}
          >
            <IconMail size={14} />
          </SidebarSuccessManagerEmail>
        </SidebarSuccessManagerCard>
      </SidebarSuccessManagerSection>
    </DarkTooltip>
  );
};

export default SidebarSuccessManager;
